export default __webpack_public_path__ + "static/media/logo-visite-plus.552687ea.png";